import { useState } from "react";

import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";

import { CopyContentIcon } from "@dotnet/telematics-design-system";

import Button, { BUTTON_COLORS, BUTTON_VARIANTS } from "../Button";
import { TOOLTIP_PLACEMENT, TooltipGeneral } from "../Tooltips";
import { CopyButtonProps } from "./types";

const CopyButton = ({
    size,
    copiedValue,
    title,
    isDisabled,
    disabledTooltipValue,
    innerContainerCss,
    ...props
}: CopyButtonProps) => {
    const { t } = useTranslation();

    const [copied, setCopied] = useState(false);

    const button = (
        <Button
            {...props}
            color={BUTTON_COLORS.Secondary}
            size={size}
            variant={
                title ? BUTTON_VARIANTS.IconLeft : BUTTON_VARIANTS.IconOnly
            }
            icon={<CopyContentIcon />}
            disabled={isDisabled}
            containerStyles={innerContainerCss}
        >
            {title}
        </Button>
    );

    return isDisabled ? (
        <TooltipGeneral
            placement={TOOLTIP_PLACEMENT.Top}
            title={disabledTooltipValue}
            disableTouchListener
        >
            <span>{button}</span>
        </TooltipGeneral>
    ) : (
        <CopyToClipboard text={copiedValue} onCopy={() => setCopied(true)}>
            <TooltipGeneral
                placement={TOOLTIP_PLACEMENT.Top}
                title={
                    copied
                        ? t("Button##copied")
                        : t("Button##copy to clipboard")
                }
                slotProps={{
                    transition: {
                        onExited: () => setCopied(false)
                    }
                }}
                disableTouchListener
            >
                {button}
            </TooltipGeneral>
        </CopyToClipboard>
    );
};

export default CopyButton;
